import { createComponent } from '@carvana/merch-components';
import CarvanaEmblem from '~/icons/CarvanaEmblem';

export const RBRLeadHeading = createComponent('h1', {
  className:
    'tracking-tight text-blue-6 s:mb-16 s:tl-header-xl l:mb-24 l:tl-header-xxl'
});

export const RBRDescription = createComponent('p', {
  className: 'text-center text-grey-5 s:tl-body-m l:tl-body-l'
});

export const CarvanaEmblemFinal = createComponent(CarvanaEmblem, {
  className: 'w-56 m:w-64 l:w-80'
});

export const EmblemContainer = createComponent('div', {
  className:
    'ml-16 inline-flex h-56 justify-center s:mb-24 s:mt-56 m:ml-20 m:mt-80 m:h-64 l:mb-32 l:mt-[75px] l:h-80'
});
